import React from "react";
import "./header.css";
import { Link } from "react-router-dom";
import { BsMoonFill, BsSunFill } from "react-icons/bs";
import Logo from "./logo";
import TopSearchBox from "../search/topSearchbox";
import BoxMenuDrop from "./boxmenudrop";
import ProfileMenuDrop from "./profilemenudrop";
import ChatToggleButton from "../chat/ChatToggleButton";
import { useTheme } from "../../shared/theme/ThemeContext";

const Header = () => {
  const { darkMode, toggleDarkMode } = useTheme();

  return (
    <div className="menu">
      <div className="menu-section">
        <Link to="/" style={{ textDecoration: "none" }}>
          <Logo />
        </Link>
        <div className="topmenu-menu-search menu-search">
          <TopSearchBox />
        </div>
      </div>
      <div className="menu-section">
        <div className="header-profile-icons">
          <ChatToggleButton />
          <button
            onClick={toggleDarkMode}
            className="theme-toggle"
            aria-label="Toggle dark mode"
            aria-pressed={darkMode}
          >
            {darkMode ? <BsSunFill /> : <BsMoonFill />}
          </button>
          <BoxMenuDrop />
          <ProfileMenuDrop />
        </div>
      </div>
    </div>
  );
};

export default Header;
